module.exports = __webpack_public_path__ + "static/media/tablet-about.decf6f7b.png";